import React from 'react';
import { Header, Footer } from '../HeaderFooter';

interface PublicLayoutProps {
    children: React.ReactNode;
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
    return (
        <>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg"
            >
                Skip to main content
            </a>
            <Header />
            <main id="main-content" className="flex-grow pt-16">
                {children}
            </main>
            <Footer />
        </>
    );
};